import { useMemo } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { MoneyType, formatServerMoney } from '@razz-team/utils';

export type UiMoneyOperator = '+' | '-' | '*' | '/' | '=';

export interface MoneyMathProps extends Omit<TypographyProps, 'children'> {
  leftValue: MoneyType | null | undefined;
  rightValue: MoneyType | null | undefined;
  operator: UiMoneyOperator;
}

export function MoneyMath({ leftValue, rightValue, operator, ...props }: MoneyMathProps) {
  const left = useMemo(() => formatServerMoney(leftValue), [leftValue]);
  const right = useMemo(() => formatServerMoney(rightValue), [rightValue]);

  return <Typography {...props}>{`${left} ${operator} ${right}`}</Typography>;
}
